import { render, staticRenderFns } from "./PptFooter.vue?vue&type=template&id=7051e058&"
import script from "./PptFooter.vue?vue&type=script&lang=js&"
export * from "./PptFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7051e058')) {
      api.createRecord('7051e058', component.options)
    } else {
      api.reload('7051e058', component.options)
    }
    module.hot.accept("./PptFooter.vue?vue&type=template&id=7051e058&", function () {
      api.rerender('7051e058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptFooter.vue"
export default component.exports